import { ITimeTrackerState } from '../types';

export const TIME_TRACKER_LOCALSTORAGE = 'TIME_TRACKER_LOCALSTORAGE';

export interface ITimeTrackerLocalStorage extends ITimeTrackerState {
};
